import Vue from 'vue'
import helpers from './lecard-helper'
import reqs from './req-helper'
import server from './server-helper'

const plugin = {
  install () {
    Vue.helpers = helpers
    Vue.prototype.$helpers = helpers
    Vue.prototype.$req = reqs
    Vue.prototype.$server = server
  }
}

export default plugin;
